import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import {
  browserLocalPersistence,
  getAuth,
  setPersistence,
} from "firebase/auth";
import { User } from "../store/user.store";

export const app = initializeApp({
  apiKey: "AIzaSyAAV4EEVw1ZtLNrsMpmjd6lDkuzxFb3pDY",
  authDomain: "oj-platform.firebaseapp.com",
  databaseURL: "https://oj-platform-default-rtdb.firebaseio.com",
  projectId: "oj-platform",
  storageBucket: "oj-platform.appspot.com",
  messagingSenderId: "461701534868",
  appId: "1:461701534868:web:16db4d568a93a62382d081",
  measurementId: "G-E3ZPGV6PB7",
});

export const auth = getAuth(app);
export const analytics = getAnalytics(app);

// Initialize Firebase auth persistence
export const initializeFirebaseAuth = async () => {
  try {
    await setPersistence(auth, browserLocalPersistence);
  } catch (error) {
    console.error("Error setting auth persistence:", error);
  }
};

export type FirebaseAuthUser = {
  apiKey: string;
  appName: string;
  createdAt: string;
  email: string;
  emailVerified: boolean;
  isAnonymous: boolean;
  lastLoginAt: string;
  providerData: {
    displayName: string | null;
    email: string;
    phoneNumber: string | null;
    photoURL: string | null;
    providerId: string;
    uid: string;
  }[];
  stsTokenManager: {
    refreshToken: string;
    accessToken: string;
    expirationTime: number;
  };
  uid: string;
};

export const getFirebaseLocalStorageUser = (): User | null => {
  try {
    const userKey = `loggedInUser`;
    const userJson = localStorage.getItem(userKey);

    if (!userJson) return null;

    const user: User = JSON.parse(userJson);

    return user;
  } catch (err) {
    console.error("Error parsing Firebase user from localStorage:", err);
    return null;
  }
};
